"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskType = void 0;
var TaskType;
(function (TaskType) {
    TaskType["Maintenance"] = "Maintenance";
    TaskType["Custom"] = "Custom";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
//# sourceMappingURL=scheduleInterfaces.js.map